export default function DeliverySection() {
  const deliveryApps = [
    {
      name: "Uber Eats",
      url: "https://www.ubereats.com/mx/store/san7o-pecado-tecnologico/xXg92ZB0WLmPWk35OAPESQ?diningMode=DELIVERY&surfaceName=",
      image:
        "https://readdy.ai/api/search-image?query=Minimalist%20food%20delivery%20badge%20illustration%20bright%20green%20background%20white%20scooter%20silhouette%20clean%20modern%20flat%20design%20simple%20geometric%20style%20no%20text%20high%20quality&width=380&height=160&seq=uber-badge-001&orientation=landscape",
      color: "#06C167",
      colorHover: "#04a155",
      accentBg: "bg-[#e8f5ee]",
      accentText: "text-[#06C167]",
      description: "Entrega rápida y segura a tu puerta",
    },
    {
      name: "Didi Food",
      url: "https://web.didiglobal.com/mx/food/toluca-mex/san7o-pecado-tecnologico/5764607761355376665/",
      image:
        "https://readdy.ai/api/search-image?query=Minimalist%20food%20delivery%20badge%20illustration%20bright%20orange%20background%20white%20motorcycle%20silhouette%20clean%20modern%20flat%20design%20simple%20geometric%20style%20no%20text%20high%20quality&width=380&height=160&seq=didi-badge-001&orientation=landscape",
      color: "#FF7700",
      colorHover: "#e66900",
      accentBg: "bg-[#fff3e6]",
      accentText: "text-[#FF7700]",
      description: "Tu postre favorito en minutos",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <span className="text-xs font-semibold text-[#d4607a] uppercase tracking-widest">
          Delivery
        </span>
        <h2
          className="text-3xl md:text-4xl font-bold text-[#2d1a0e] mt-2"
        >
          ¿Prefieres en Casa?
        </h2>
        <p className="text-[#7a5c44] text-sm mt-2 mb-10">
          Disfruta de San7o Pecado desde la comodidad de tu hogar
        </p>

        <div className="flex flex-col sm:flex-row gap-5 md:gap-6 justify-center items-stretch">
          {deliveryApps.map((app) => (
            <a
              key={app.name}
              href={app.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex-1 max-w-sm bg-white rounded-2xl border border-[#f0e8f5] overflow-hidden hover:border-[#e0e0e0] transition-all duration-300 cursor-pointer text-left"
            >
              {/* Banner image */}
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={app.image}
                  alt={`${app.name} delivery`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/5"></div>
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full ${app.accentBg}`}
                  >
                    <i
                      className={`ri-motorbike-line text-lg ${app.accentText}`}
                    ></i>
                  </div>
                  <h3 className="font-bold text-[#2d1a0e] text-lg">
                    {app.name}
                  </h3>
                </div>
                <p className="text-[#7a5c44] text-xs mb-4 pl-[52px]">
                  {app.description}
                </p>
                <div
                  className="inline-flex items-center gap-2 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors ml-[52px]"
                  style={{ backgroundColor: app.color }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = app.colorHover)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = app.color)
                  }
                >
                  Ordenar Ahora{" "}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}